module.exports = require("./matches-selector.js");


//////////////////
// WEBPACK FOOTER
// desandro-matches-selector (bower component)
// module id = 431
// module chunks = 0